import { SearchFilterTag } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import { ImplementationMethodLabelModifier } from '@/utils/enum';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const ImplementationMethodsTag: FC = () => {
  const { t } = useTranslation();

  const { control: sharedSearchControl, setValue: setSharedSearchValue } =
    useFormContext<SharedSearchFormType>();
  const { control: projectSearchControl } =
    useFormContext<ProjectSearchFormType>();

  const [sheetType, implementationMethods] = useWatch({
    control: sharedSearchControl,
    name: ['sheetType', 'implementationMethods'],
  });
  const skipAdministrativeReformTeamEvaluation = useWatch({
    control: projectSearchControl,
    name: 'skipAdministrativeReformTeamEvaluation',
  });

  if (
    sheetType !== 'RS' ||
    (sheetType === 'RS' && skipAdministrativeReformTeamEvaluation === 'true') ||
    !implementationMethods?.length
  ) {
    return null;
  }

  const value =
    implementationMethods
      ?.map((item) => ImplementationMethodLabelModifier[item])
      ?.join(', ') ?? '';

  return (
    <SearchFilterTag
      closable={true}
      label={`${t('implementation-method')}: ${value}`}
      onClose={() => {
        setSharedSearchValue('implementationMethods', null);
      }}
    />
  );
};
